const initialState = false;

export const handleTaskView = (state = initialState, action) => {
    switch (action.type) {
        case "toggleTaskView": 
        return state = !state
        case "enableTaskView":
            return state = true
        case "disableTaskView":
            return state = false
        default: return state
    }

}



export default handleTaskView;